import React, { useState, useEffect, useRef } from 'react'
import MaterialUIPickers from 'app/components/datepickers/MaterialUIPickers'
import { Icon, Avatar, Divider, Typography } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import Formsy from 'formsy-react'
import { TextInput } from 'app/components/FormsyHelperComponent'
import PhoneNumberInputFormsy, {
  validatePhoneNumber,
} from 'app/components/PhoneNumberInputFormsy'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import { emailRegExpFormat } from 'commons/email'
import GroupSelect from 'app/components/GroupSelect'
import Assets from 'app/configs/assetConfigs'
import CancelButton from 'app/components/buttons/CancelButton'
import DestructiveButton from 'app/components/buttons/DestructiveButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import ResponsiveDialogAction from 'app/components/dialog/ResponsiveDialogAction'
import ResponsiveDialogContent from 'app/components/dialog/ResponsiveDialogContent'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import * as R from 'ramda'
import IconInputRow, { ItemType } from 'app/components/input/IconInputRow'
import ResponsiveAppbar, {
  AppbarDisplayName,
} from 'app/components/dialog/ResponsiveAppbar'
import { renderLanguage } from 'app/components/selector/LanguageRenderItem'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import effects from 'app/effects/effects'
import { usePlace } from 'commons/usePlace'
import { parsedPhoneNumber } from 'commons/phoneNumber'
import { useFlag } from '@unleash/proxy-client-react'

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: 96,
    height: 96,
  },
  closeIcon: {
    position: 'absolute',
    zIndex: 1101,
    right: '10px',
    color: theme.palette.primary.contrastText,
    top: '10px',
    cursor: 'pointer',
  },
}))

export default (props) => {
  const {
    state,
    setState,
    toggleDialogs,
    EDIT_SUBSCRIBER_DIALOG,
    editSubscriberRequest,
    refetchData,
  } = props

  const subscriberStatus = {
    APPROVED: 3,
    REJECT: 6,
    UNVERIFIED: 11,
  }

  let initialState = {
    isChangedForm: false,
  }
  const [localState, setLocalState] = useState(initialState)
  useEffect(() => {
    let formRestrictionLevel = 0
    if (state.editSubscriberData.lastInvitationStatus === 1) {
      formRestrictionLevel = 1
    } else if (state.editSubscriberData.lastInvitationStatus > 1) {
      formRestrictionLevel = 2
    }

    setState((state) => ({
      ...state,
      formRestrictionLevel,
    }))
  }, [state.editSubscriberData.lastInvitationStatus, setState])

  const handleEditSubscriber = async () => {
    try {
      await editSubscriberRequest(state.editSubscriberData)
      if (!Array.isArray(state.editSubscriberData.tags)) {
        state.editSubscriberData.tags =
          state.editSubscriberData.originalTags.map((tag) => tag.id)
      }
      toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
    } catch (e) {
      if (e && e.response && e.response.data && e.response.data.details) {
        if (e.response.data.details.code === 602) {
          dispatchRedux(
            MessageAlert.showError({
              message:
                e.response.data.details.message.errors[
                  Object.keys(e.response.data.details.message.errors)[0]
                ],
            }),
          )
        } else {
          dispatchRedux(
            MessageAlert.showError({
              message: e.response.data.details.message,
            }),
          )
        }
      }
    }
  }

  const dispatchRedux = useDispatch()
  const place = usePlace()

  const handleChange = (fieldName) => (e) => {
    const value = e.target.value

    setState({
      ...state,
      editSubscriberData: {
        ...state.editSubscriberData,
        [fieldName]: value,
      },
      isFormEmailPhoneValid: value || state.editSubscriberData.phoneNumber,
    })
  }

  const handleChangeBirthDay = (data) => {
    formBtnActivity(true)

    setState({
      ...state,
      editSubscriberData: {
        ...state.editSubscriberData,
        birthday: data,
      },
    })
  }

  const handlePhoneNumber = (fullPhoneNumber) => {
    formBtnActivity(true)
    const parsed = parsedPhoneNumber(fullPhoneNumber)
    setState({
      ...state,
      editSubscriberData: {
        ...R.prop('editSubscriberData', state),
        ...parsed,
        isFormEmailPhoneValid:
          state.editSubscriberData.email || R.prop('phoneNumber', parsed),
      },
    })
  }

  const handleTagsChange = async (tags) => {
    formBtnActivity(true)

    setState({
      ...state,
      editSubscriberData: {
        ...state.editSubscriberData,
        tags,
      },
    })
  }

  const { formatMessage } = useIntl()

  const isRequiredLocalized = formatMessage({
    id: 'error.form.required',
  })

  const onChangeForm = (elem) => {
    formBtnActivity(true)
  }

  function formBtnActivity(isChangedForm) {
    if (localState.isChangedForm !== isChangedForm) {
      setLocalState({
        ...localState,
        isChangedForm,
      })
    }
  }

  //Submit
  const formRef = useRef()
  const subscriberId = state.editSubscriberData.id
  const isHideContact = state.editSubscriberData.hideContacts
  const callSubmit = () => {
    if (!R.isNil(formRef.current)) formRef.current.submit()
  }

  const language = R.path(
    ['editSubscriberData', 'parents', 0, 'language', 'languageDetails'],
    state,
  )
  function checkPendingButtonGroup() {
    if (state.editSubscriberData.lastInvitationStatus === 2) {
      return (
        <ResponsiveDialogAction
          StartButton={
            <DestructiveButton
              onClick={() =>
                effects.apis
                  .approveSubscriber({
                    placeId: place.id,
                    ids: [subscriberId],
                    status: subscriberStatus.REJECT,
                  })
                  .then(() => {
                    toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
                    refetchData()
                  })
                  .catch((error) => {
                    dispatchRedux(
                      MessageAlert.showNetworkError(formatMessage)(error),
                    )
                  })
              }
              className="w-full"
            >
              <FormattedMessage id="rejectBtn" />
            </DestructiveButton>
          }
          EndButton={
            <PrimaryButton
              onClick={() =>
                effects.apis
                  .approveSubscriber({
                    placeId: place.id,
                    ids: [subscriberId],
                    status: subscriberStatus.UNVERIFIED,
                  })
                  .then(() => {
                    toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
                    refetchData()
                  })
                  .catch((error) => {
                    dispatchRedux(
                      MessageAlert.showNetworkError(formatMessage)(error),
                    )
                  })
              }
              className="w-full"
            >
              <FormattedMessage id="acceptBtn" />
            </PrimaryButton>
          }
        />
      )
    } else {
      return (
        <ResponsiveDialogAction
          StartButton={
            <CancelButton
              onClick={() => {
                toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
              }}
              className="w-full"
            >
              <FormattedMessage id="cancelBtn" />
            </CancelButton>
          }
          EndButton={
            <PrimaryButton
              onClick={callSubmit}
              disabled={localState.isChangedForm ? !state.isFormValid : true}
              className="w-full"
            >
              <FormattedMessage id="saveBtn" />
            </PrimaryButton>
          }
        />
      )
    }
  }

  return (
    <ResponsiveDialog removeAllSpace scroll="paper" maxWidth="xs" open={true}>
      <Formsy className="flex flex-col overflow-hidden">
        <Icon
          className={clsx(useStyles().closeIcon)}
          onClick={() => {
            toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
          }}
        >
          close
        </Icon>
        <ResponsiveAppbar
          avatar={
            <Avatar
              className={clsx(useStyles().avatar, 'avatar')}
              alt="avatar"
              src={
                state.editSubscriberData.avatar &&
                state.editSubscriberData.avatar !== ''
                  ? state.editSubscriberData.avatar
                  : Assets.personSilhouetteImage
              }
            />
          }
          displayName={
            <AppbarDisplayName>
              {`${state.editSubscriberData.firstName} ${state.editSubscriberData.lastName}`}
            </AppbarDisplayName>
          }
        />

        <ResponsiveDialogContent>
          <Formsy
            ref={formRef}
            onValidSubmit={handleEditSubscriber}
            className="flex flex-col md:overflow-hidden"
            id="createGroup"
            onValid={() => setState({ ...state, isFormValid: true })}
            onChange={onChangeForm}
            onInvalid={() => setState({ ...state, isFormValid: false })}
          >
            <IconInputRow
              itemType={ItemType.First}
              IconComponent={<Icon>account_circle_outlined_icon</Icon>}
              Input={
                <TextInput
                  onBlur={handleChange('firstName')}
                  margin="dense"
                  containerClassName="MuiFormControl-fullWidth"
                  labelId="firstName.label"
                  placeholderId="firstName.label"
                  name="firstName"
                  variant="outlined"
                  rows={5}
                  autoFocus
                  fullWidth
                  required
                  disabled={state.formRestrictionLevel > 1}
                  value={state.editSubscriberData.firstName}
                  validations={{
                    isNotBlank: (values, value) => {
                      return value !== '' ? true : isRequiredLocalized
                    },
                  }}
                />
              }
            />
            <IconInputRow
              IconComponent={<Icon>account_circle_outlined_icon</Icon>}
              Input={
                <TextInput
                  onBlur={handleChange('lastName')}
                  margin="dense"
                  containerClassName="MuiFormControl-fullWidth"
                  labelId="lastName.label"
                  placeholderId="lastName.label"
                  name="lastName"
                  variant="outlined"
                  rows={5}
                  autoFocus
                  fullWidth
                  required
                  disabled={state.formRestrictionLevel > 1}
                  value={state.editSubscriberData.lastName}
                  validations={{
                    isNotBlank: (values, value) => {
                      return value !== '' ? true : isRequiredLocalized
                    },
                  }}
                />
              }
            />
            <IconInputRow
              IconComponent={<Icon>person_outline_icon</Icon>}
              Input={
                <TextInput
                  onBlur={handleChange('uniqueId')}
                  margin="dense"
                  containerClassName="MuiFormControl-fullWidth"
                  labelId="subscriber.label.uniqueId"
                  placeholderId="subscriber.label.uniqueId"
                  name="uniqueId"
                  variant="outlined"
                  rows={5}
                  fullWidth
                  value={state.editSubscriberData.uniqueId}
                />
              }
            />
            <IconInputRow
              IconComponent={<Icon>folder_shared_outlined_icon</Icon>}
              Input={
                <GroupSelect
                  selectedTags={state.editSubscriberData.tags}
                  onTagsChange={handleTagsChange}
                />
              }
            />
            <IconInputRow
              IconComponent={<Icon>cake_outlined_icon</Icon>}
              Input={
                isHideContact ? (
                  <RestrictedText
                    name="birthday"
                    labelId="subscriber.label.dateOfBirth"
                    placeholderId="subscriber.label.dateOfBirth"
                  />
                ) : (
                  <MaterialUIPickers
                    value={state.editSubscriberData.birthday}
                    disabled={state.formRestrictionLevel > 1}
                    handleDateChange={handleChangeBirthDay}
                  />
                )
              }
            />
            {language && (
              <IconInputRow
                IconComponent={<Icon>g_translate</Icon>}
                Input={
                  <TextInput
                    disabled={true}
                    name="langauge"
                    variant="outlined"
                    labelId="languageSubscriber.label"
                    placeholderId="languageSubscriber.label"
                    value={renderLanguage(language)}
                  />
                }
              />
            )}
            <Divider color="secondary" />
            <Typography variant="caption" className="pb-8 pt-16 mb-16">
              <FormattedMessage id="subscriber.form.info.text" />
            </Typography>
            <IconInputRow
              IconComponent={<Icon>mail_outline_outlined_icon</Icon>}
              Input={
                isHideContact ? (
                  <RestrictedText
                    name="email"
                    labelId="email.address.label"
                    placeholderId="email.address.label"
                  />
                ) : (
                  <TextInput
                    onChange={handleChange('email')}
                    margin="dense"
                    containerClassName="MuiFormControl-fullWidth"
                    labelId="email.address.label"
                    placeholderId="email.address.label"
                    name="email"
                    variant="outlined"
                    rows={5}
                    autoFocus
                    fullWidth
                    disabled={state.formRestrictionLevel > 0}
                    value={state.editSubscriberData.email}
                    validations={{
                      matchRegexp: emailRegExpFormat,
                      isNotBlank: (values, value) => {
                        return value === '' && !values.fullPhoneNumber
                          ? isRequiredLocalized
                          : true
                      },
                    }}
                    validationErrors={{
                      matchRegexp: formatMessage({
                        id: 'login.textField.validation.email',
                      }),
                    }}
                  />
                )
              }
            />
            <IconInputRow
              itemType={ItemType.Last}
              IconComponent={<Icon>phone</Icon>}
              Input={
                isHideContact ? (
                  <RestrictedText
                    name="fullPhoneNumber"
                    labelId="phone.label"
                    placeholderId="phone.label"
                  />
                ) : (
                  <PhoneNumberInputFormsy
                    name="fullPhoneNumber"
                    label={formatMessage({
                      id: 'phone.label',
                    })}
                    className="w-full"
                    autoComplete="new-password"
                    enableSearchField
                    disableSearchIcon
                    disableAreaCodes={true}
                    onChange={handlePhoneNumber}
                    value={
                      state.editSubscriberData.phoneNumber
                        ? state.editSubscriberData.countryCode +
                          state.editSubscriberData.phoneNumber
                        : '+1'
                    }
                    defaultCountry={'us'}
                    disabled={state.formRestrictionLevel > 0}
                    validations={{
                      isPhoneNumber: (values, value) => {
                        return (
                          value === state.editSubscriberData.countryCode ||
                          validatePhoneNumber(values, value)
                        )
                      },
                      isNotBlank: (values, value) => {
                        return value === '+' && !values.email
                          ? isRequiredLocalized
                          : true
                      },
                    }}
                    validationErrors={{
                      isPhoneNumber: formatMessage({
                        id: 'registerForm.phoneNumberInvalid',
                      }),
                    }}
                    isScrollWhenFocus
                  />
                )
              }
            />
          </Formsy>
        </ResponsiveDialogContent>
        {checkPendingButtonGroup()}
      </Formsy>
    </ResponsiveDialog>
  )
}

const RestrictedText = (props) => {
  const { formatMessage } = useIntl()

  return (
    <TextInput
      value={formatMessage({
        id: 'subscriber.label.restricted',
      })}
      disabled
      {...props}
    />
  )
}
